import { Observable } from "rxjs"

import ClinicGroup, { ClinicGroupSelected } from "./Models/ClinicGroup"
import ClinicGroupFF from "./Models/ClinicGroupFF"
import { ObservableFromFetch } from "../ObservableFromFetch"

export function GetExcludedClinicGroupsObservable(): Observable<ClinicGroup[]> {
  return ObservableFromFetch<ClinicGroup[]>("WorkforceClinicGroups/GetExcludedClinicGroups")
}

export function GetFFClinicGroupsObservable(): Observable<ClinicGroupFF[]> {
  return ObservableFromFetch<ClinicGroupFF[]>("WorkforceClinicGroups/GetFFClinicGroups")
}

export function SetExcludedClinicGroupsObservable(groups: ClinicGroupFF[]): Observable<string> {
  const requestBody: string = JSON.stringify(groups)
  return ObservableFromFetch<string>("WorkforceClinicGroups/ManageExcludedClinicGroups", requestBody)
}

export function DeleteExcludedClinicGroupsObservable(groups: ClinicGroupSelected[]): Observable<string> {
  const requestBody: string = JSON.stringify(groups)
  return ObservableFromFetch<string>("WorkforceClinicGroups/DeleteExcludedClinicGroups", requestBody)
}
